import React from 'react';

export default function OverdueSection({ events, onUpdateEvent, formatDate }) {
  if (events.length === 0) {
    return (
      <div className="card text-center py-4 sm:py-6 text-on-surface-variant">
        <span className="text-xl sm:text-2xl mr-2">✓</span> <span className="text-sm sm:text-base">No overdue items</span>
      </div>
    );
  }

  const daysOverdue = (dateStr) => {
    const today = new Date();
    const dueDate = new Date(dateStr);
    const diff = Math.floor((today - dueDate) / (1000 * 60 * 60 * 24));
    return diff;
  };

  const getCriticalityColor = (days) => {
    if (days > 14) return 'bg-error';
    if (days > 7) return 'bg-tertiary';
    return 'bg-secondary';
  };

  return (
    <div className="space-y-2">
      {events.map((event) => {
        const days = daysOverdue(event.date);
        return (
          <div key={event.id} className={`card p-3 sm:p-4 border-l-4 ${getCriticalityColor(days)}`}>
            <div className="flex flex-col sm:flex-row items-start sm:items-start justify-between gap-2 sm:gap-3">
              <div className="flex-1 min-w-0">
                <h4 className="font-bold text-sm sm:text-base break-words">{event.title}</h4>
                <p className="text-xs text-on-surface-variant mt-1">
                  Due: {formatDate(event.date)} ({days} days ago)
                </p>
                {event.description && (
                  <p className="text-xs sm:text-sm text-on-surface-variant mt-1 line-clamp-2">{event.description}</p>
                )}
              </div>
              <button
                onClick={() => onUpdateEvent(event.id, { status: 'completed' })}
                className="badge badge-primary hover:opacity-80 text-xs whitespace-nowrap"
              >
                Mark Done
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
